export const CHECK_PROFILE_STATE_INT_VALUE = 10000;
